import Loading from '~/components/Loading';
import Question from '~/components/forms/Question';
import { useMemo } from 'react';

const EditFormQuestions = ({ questions, isLoading, answers, setAnswers }) => {
    const sectionQuestions = useMemo(() => {
        const sections = {};
        const sectionQuestions = [];

        if (!questions) {
            return [];
        }

        questions.forEach(q => {
            if (!sections[q.form_section_id]) {
                sections[q.form_section_id] = [];
                sectionQuestions.push({
                    section_id: q.form_section_id,
                    questions: sections[q.form_section_id],
                });
            }
            sections[q.form_section_id].push(q);
        });

        return sectionQuestions;
    }, [questions]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            {sectionQuestions.map((section, idx) => (
                <div
                    className={
                        idx > 0
                            ? 'border-t border-gray-400 mt-6 pt-6'
                            : ''
                    }
                    key={section.section_id}
                >
                    {section.questions.map(q => (
                        <Question
                            key={q.id}
                            question={q}
                            value={answers[q.id]}
                            setValue={newValue =>
                                setAnswers(old => ({
                                    ...old,
                                    [q.id]: newValue,
                                }))
                            }
                            id={`answers.${q.id}`}
                            className="mb-4"
                        />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default EditFormQuestions;

